import { ContentState, Editor, EditorState, convertFromHTML } from 'draft-js'
import React, { FC, useMemo } from 'react'

export type RichTextPanelProps = {
  text?: string | null
  className?: string
}

const RichTextPanel: FC<RichTextPanelProps> = ({ text, className }) => {
  const renderedRichText = useMemo(() => {
    const contentBlock = convertFromHTML(text || '')
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
    const editorState = EditorState.createWithContent(contentState)
    return (
      <div className={['draftjs-display-readonly', className].filter(Boolean).join(' ')}>
        <Editor editorState={editorState} readOnly={true} onChange={() => null} />
      </div>
    )
  }, [text, className])

  return renderedRichText
}

export default RichTextPanel
